function PreBlock({ children }) {
    return (
        <pre
            style={{
                textAlign: 'left',
                fontSize: '0.8em',
                border: '1px solid #ccc',
                padding: '10px',
                backgroundColor: '#f9f9f9',
                fontWeight: 'bold',
                // Long code lines scroll within the block instead of overflowing the card.
                overflowX: 'auto',
                maxWidth: '100%',
            }}
        >
            {children}
        </pre>
    );
}
export default PreBlock;
